export default __webpack_public_path__ + "static/media/i71.51b935b8.jpg";